@use 'src/stylesheets/variables/spacings';

.syncStatus {
  margin-top: spacings.$s-20;
}